import React from 'react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_NAME } from '../data/constants';
const QUESTIONS = ['Which recipe should you use?', 'How do you get consistently soft rolls?', 'How do you make different flavors?', 'How do you make them look professional?', 'How do you prepare multiple batches?', 'How do you keep the quality consistent?', 'How do you turn a homemade recipe into something you can confidently offer to customers?'];
const FLAVORS = ['Classic.', 'Chocolate.', 'Caramel.', 'Fruit.', 'Nut.', 'Coffee.', 'Premium flavors.'];
export function ProblemSections() {
  return <>
      <section className="border-b-4 border-cinnamon/30 bg-cream px-4 py-6" data-id="element-162" data-mp="gl5dt5ed9llv">
        <div className="mx-auto max-w-3xl" data-id="element-163" data-mp="ljqgdbh3chdh">
          <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-164" data-mp="lkrujoteljzf">
            What If Your Next Income Stream <span className="text-burnt" data-id="element-165" data-mp="2avslzfam7nuc">Started In Your Kitchen?</span>
          </h2>
          <div className="mt-3 space-y-1 text-sm font-semibold leading-snug text-espresso/85 sm:text-base" data-id="element-166" data-mp="2fulz36lzpctz">
            <p data-id="element-167" data-mp="38xu931aa8b80">You don&apos;t need a bakery.</p>
            <p data-id="element-168" data-mp="34015mg0d5vbf">You don&apos;t need a huge menu.</p>
            <p data-id="element-169" data-mp="33z9jrwwkjbyc">You don&apos;t need years of professional pastry training.</p>
            <p className="font-extrabold text-espresso" data-id="element-170" data-mp="3hrpgkfyvmdqt">
              You need a product people already know, love, crave — and buy.
            </p>
            <p data-id="element-171" data-mp="2q0t25ax6411f">And you need to know how to make it properly.</p>
            <p className="text-cinnamon" data-id="element-172" data-mp="2q3fbng3mcqma">
              Soft dough. Rich cinnamon filling. Beautiful spirals. Creamy frosting. Premium flavors. Professional
              presentation.
            </p>
            <p className="font-extrabold text-espresso" data-id="element-173" data-mp="2yzwpir3db2lq">
              {PRODUCT_NAME} gives you the complete system to go from ingredients on your counter to cinnamon rolls
              ready to offer and sell.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-espresso px-4 py-6 text-cream" data-id="element-174" data-mp="9c5q1oplb9fg">
        <div className="mx-auto max-w-3xl" data-id="element-175" data-mp="3356t0i3zyohx">
          <h2 className="text-center text-xl sm:text-3xl" data-id="element-176" data-mp="334dshyvmsv88">😰 Stop Wondering Where To Start</h2>
          <p className="mt-2 text-sm font-semibold text-cream/85 sm:text-base" data-id="element-177" data-mp="3826xwpp41l7g">
            Maybe you&apos;ve already thought about selling something homemade. But then the questions begin.
          </p>
          <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-178" data-mp="3h3n8axfxdnbo">
            {QUESTIONS.map(question => <li key={question} className="rounded border-l-4 border-gold bg-espressoLight px-3 py-2 text-sm font-semibold text-cream/90" data-id="element-179" data-mp="2kg0df3yi2d0c">
                {question}
              </li>)}
          </ul>
          <p className="mt-3 text-center text-base font-extrabold text-gold sm:text-lg" data-id="element-180" data-mp="2y6m1r86q3f5m">
            You don&apos;t need another random recipe. You need the complete process.
          </p>
        </div>
      </section>

      <section className="bg-creamDeep px-4 py-6" data-id="element-181" data-mp="25nou6f5w4b3l">
        <div className="mx-auto max-w-3xl" data-id="element-182" data-mp="1y5ibasqsoctx">
          <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-183" data-mp="1y4fhod237wab">⚠️ A Good Recipe Isn&apos;t Enough</h2>
          <div className="mt-3 space-y-1.5 text-sm font-semibold leading-snug text-espresso/85 sm:text-base" data-id="element-184" data-mp="1t7grg5ljo9he">
            <p data-id="element-185" data-mp="1o9nnlj7prrka">Anyone can find a cinnamon roll recipe online.</p>
            <p className="font-extrabold text-espresso" data-id="element-186" data-mp="1k4xu210j2p2j">
              But finding a recipe and building a product you can confidently sell are two very different things.
            </p>
            <p data-id="element-187" data-mp="1afw9dxj1fji8">
              You need to understand: the ingredients, the dough, the fermentation, the filling, the shaping, the
              baking, the frosting, the flavors, the finishing, the presentation, and the consistency.
            </p>
            <p data-id="element-188" data-mp="10fx5idxkchbp">
              Because if you want to earn income from what you make, your customer shouldn&apos;t receive an experiment.
            </p>
            <p className="font-extrabold text-burnt" data-id="element-189" data-mp="rid0ctwky0vt">They should receive a product you&apos;re proud to sell.</p>
          </div>
        </div>
      </section>

      <section className="bg-cream px-4 py-6" data-id="element-190" data-mp="2rlxgup4chp9k">
        <div className="mx-auto max-w-3xl" data-id="element-191" data-mp="2vk3kho9vzoq9">
          <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-192" data-mp="2vmze50epbr8w">
            💰 Turn Cinnamon Rolls Into <span className="text-burnt" data-id="element-193" data-mp="2hrxayl18ofzs">An Income Opportunity</span>
          </h2>
          <p className="mt-2 text-sm font-semibold text-espresso/85 sm:text-base" data-id="element-194" data-mp="2mqqfvp2gmyoc">
            Imagine being able to create your own cinnamon rolls from scratch.
          </p>
          <ul className="mt-2.5 flex flex-wrap justify-center gap-1.5" data-id="element-195" data-mp="2cvggza7cz7es">
            {FLAVORS.map(flavor => <li key={flavor} className="rounded-full border-2 border-cinnamon bg-white px-3 py-1 text-xs font-extrabold uppercase text-cinnamon sm:text-sm" data-id="element-196" data-mp="1ywqh5mt5mtmq">
                {flavor}
              </li>)}
          </ul>
          <div className="mt-3 space-y-1 text-sm font-semibold leading-snug text-espresso/85 sm:text-base" data-id="element-197" data-mp="21auxapxa46m">
            <p data-id="element-198" data-mp="c72bfv1jwcxb">Beautifully finished and professionally presented.</p>
            <p data-id="element-199" data-mp="788xy2m9klx5">Not just to bake for yourself.</p>
            <p className="font-extrabold text-espresso" data-id="element-200" data-mp="75czmd6i7v86">
              To create something you can actually offer, sell, and build income around.
            </p>
            <p data-id="element-201" data-mp="g730saq6u8j5">{PRODUCT_NAME} shows you the process from beginning to end.</p>
          </div>
          <div className="mx-auto mt-4 max-w-md" data-id="element-202" data-mp="uw8w3nlwnelr">
            <CTAButton href={OFFER_ANCHOR} data-id="element-203" data-mp="uyv5ztw9q675">🍥 YES! I WANT TO START NOW</CTAButton>
          </div>
        </div>
      </section>
    </>;
}